import { Component, OnInit,ViewChild } from '@angular/core';
import { CashBankTransactionService} from 'app/shared/services/cash-bank-transaction.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { CashBankEntryComponent } from '../cash-bank-entry/cash-bank-entry.component';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'app-cash-bank-entry-list',
  templateUrl: './cash-bank-entry-list.component.html',
  styleUrls: ['./cash-bank-entry-list.component.css']
})
export class CashBankEntryListComponent implements OnInit {

  displayedColumns: string[] = ['transNo','type', 'date','fromAccount','toAccount', 'description', 'amount','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  data : any [];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  constructor(
    private cashBankTransactionService :CashBankTransactionService, 
    private router : Router, 
    private route : ActivatedRoute, 
    private toastr: ToastrService,   
    private themeService: NbThemeService,
    private dialogService: DialogService,
    private authService: AuthService,
   ) { }

ngOnInit() {

    this.getAll();
     this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

}
  
getControlPermissions(){
  var data = [];
   data =  this.authService.controlPermissionArray.filter((el)=>{
    return el.moduleCode ==='CB'
  });
  if(data.length > 0){
    this.crud_access.read = data[0].read;
    this.crud_access.create = data[0].create;
    this.crud_access.approve = data[0].approve;
    this.crud_access.delete = data[0].delete;
  }
}


  newButtonClick(){
    this.cashBankTransactionService.dataRow = null;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "50%";
    this.dialogService.openDialog(CashBankEntryComponent,dialogConfig)
    .afterClosed().subscribe(res => this.getAll());  
   }

   veiwButtonClick(row){
    this.cashBankTransactionService.dataRow = row;  
    const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "50%";
     this.dialogService.openDialog(CashBankEntryComponent,dialogConfig)
      .afterClosed().subscribe(res => this.getAll());

  }


  getAll(){
  this.cashBankTransactionService.getAll()
   .subscribe(
      (data) => {
                this.data = data; 
                this.dataSource = new  MatTableDataSource (this.data);  
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;      
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
    
   }
 



   deleteButtonClick(id : string){   
     this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
     .afterClosed().subscribe(res =>{
       if(res){
      this.cashBankTransactionService.deleteCashBankEntry(id)
      .subscribe(
        (res) => {
                    this.toastr.success('Deleted successfully','Success');
                    this.getAll();
                    console.log(res);     
                  },        
        (err) =>  {
                    this.toastr.error('Failed to delete record','Failure');
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  }, 
          )

      } 
    });
 }


 applyFilter(){
  this.dataSource.filter =this.searchKey.trim().toLowerCase();

 }
 onSearchClear(){
   this.searchKey = "";
   this.applyFilter();
}


}
